import { useMutation } from '@tanstack/react-query';
import { api, type AIMetricSuggestion } from '@/services/api';
import type { CampaignMetadata, MetricDefinition } from '@monitoring-panel/types';

// Re-exported so existing consumers (AIMetricSuggestionsModal) keep importing it from here.
export type { AIMetricSuggestion };

interface SuggestMetricsParams {
  metadata: CampaignMetadata;
  availableColumns: string[];
  existingMetrics: MetricDefinition[];
  campaignData: Array<Record<string, unknown>>;
}

/**
 * Suggest custom calculated metrics for a campaign.
 * All AI work (prompting Gemini + formula validation) happens server-side;
 * the result is already split into accepted / rejected.
 */
export function useAISuggestMetrics() {
  return useMutation({
    mutationFn: (params: SuggestMetricsParams) => api.ai.suggestMetrics(params),
  });
}
